module.exports = __webpack_public_path__ + "img/sankaku_65_blue.c2a8bbf6.png";